import {useHistory, useParams} from "react-router-dom";
import {useDifactoBucket} from "../../../components/utils";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import ExtractForm from "../../../components/data_products/extracts/ExtractForm";
import { useGetExtractAggregationOptionsQuery, useGetExtractQuery, useUpdateExtractMutation } from "../../../api/extractApiSlice";
import {useGetAudiencesQuery} from "../../../api/audienceApiSlice";
import {useControlledTabs} from "../../../components/Tabs";

function EditExtract(props) {
  const history = useHistory();
  const { extractId } = useParams();
  const { data: extract, isSuccess } = useGetExtractQuery(extractId)
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [tabProps,] = useControlledTabs("audience", props)
  const bucket = useDifactoBucket();
  const { data: aggregationOptions = [] } = useGetExtractAggregationOptionsQuery()
  const { data: audiences = [] } = useGetAudiencesQuery()

  const goToExtract = () => history.push({
    pathname: `/extracts/${extractId}`,
    state: {activeTab: tabProps.active}
  })

  const [updateExtract] = useUpdateExtractMutation()
  const submitProps = {
    handleSubmit: (data) => {
      updateExtract({...data, key: extractId}).unwrap()
        .then(goToExtract)
        .catch(error => {})
    },
    errors: {}
  }

  if( ! isSuccess ) { return (<></>) }
  return (
    <>
      <Title
        main={t("menu.extracts")}
        sub={extract.name}
        group={false}
        onBack={goToExtract}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToExtract} />
      </Title>
      <ExtractForm
        bucket={bucket}
        extract={extract}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        audiences={audiences}
        aggregationOptions={aggregationOptions}
        tabProps={tabProps}/>
    </>
  )
}

export default EditExtract
